import { ITerminalErrorEntry } from "../terminalError";

export interface IPaymentResponse {
	status: PAYMENT_STATUS;
	message: IPaymentMessage;
}

export interface IPaymentMessage {
	messageHeader: IMessageHeader;
	messagePayload: IMessagePayload;
}

export interface IMessageHeader {
	Integrity: string;
	MsgVersion: string;
	MsgDirection: string;
	MsgTime: string;
	MsgSequence: string;
	MsgClass: string;
	MsgType: string;
	MsgCode: string;
	MsgCompletion: boolean;
	MsgNotification: boolean;
	MsgStatus: string;
	DeviceProvider: string;
	DeviceType: string;
	DeviceNumber: string;
	EncryptionAlgorithm: string;
	EncryptionKeyIndex: string;
	EncryptionMAC: string;
}

export interface IMessagePayload {
	ID_TXN_TYPE: string;
	ID_TXN_AMOUNT: string;
	ID_TXN_DATE: string;
	ID_TXN_TIME: string;
	ID_TXN_STAN: string;
	ID_TXN_BATCH: string;
	ID_TXN_CERT: string;
	ID_TXN_CHECKSUM: string;
	ID_CARD_CAN: string;
	ID_CARD_CSN: string;
	ID_CARD_BALANCE: string;
	ID_CARD_COUNTER: string;
	ID_CARD_EXPIRY: string;
	ID_TXN_MER_REF_NUM: string;
	ID_TXN_RESPONSE_TEXT: string;
	ID_TXN_MER_NAME: string;
	ID_TXN_MER_ADDRESS: string;
	ID_TXN_TID: string;
	ID_TXN_MID: string;
	ID_TXN_SERVICE_FEE: string;
	ID_TXN_CARD_PREVIOUS_BAL: string;
	ID_TXN_PURSE_STATUS: string;
	ID_TXN_AUTOLOAD_AMOUT: string;
	ID_CARD_CEPAS_VER: string;
	ID_CARD_SCHEME_NAME: string;
	ID_TXN_INV_NUM: string;
	ID_TXN_HOST: string;
	ID_TXN_RECEIPT: string;
	ID_PADDING: string;
}

export enum PAYMENT_STATUS {
	SUCCESS = "success",
	FAIL = "fail",
}

export const PAYMENT_ERROR_CODES = {
	SOK_PAYMENT_UPDATE_FAILED: "SOK_PAYMENT_UPDATE_FAILED",
} as const;

export interface IPaymentFailureResponse {
	status?: string;
	error_code?: string;
	charged?: boolean;
	message?: string;
	error?: string;
	errors?: ITerminalErrorEntry[];
	success?: boolean | string;
}

export enum PAYMENT_METHODS {
	FLASHPAY = "flashpay",
	NETS = "nets",
	NETSQR = "netsqr",
	CREDITCARD = "creditcard",
	ALIPAY_WECHAT = "alipay_wechat",
	CASH = "cash",
}
